import React, {Fragment, useState, useEffect, useRef} from 'react'
import _ from 'lodash';
import InspectionWrapper from '../../DisplayComponents/generic/InspectionWrapper'
import BMPLocationDisplay from '../../DisplayComponents/BMPLocationDisplay';


export default function TakeMapSnapshot({reportState, saveReportForLater, handleChange, cancel, getMapImageCallback}){

    let {flexdata, loggedBMPs} = reportState;
    let [capturing, setCapturing] = useState(false)
    let [captureFailed, setCaptureFailed] = useState(false)
    let active = useRef(true);
    let timeoutId = useRef(null);

    useEffect(() => () => {
    	active.current = false;
    	clearTimeout(timeoutId.current);
    }, [])

    let onCaptureFailed = () => {
    	clearTimeout(timeoutId.current);
    	if (!active.current) return;
    	setCapturing(false);
    	setCaptureFailed(true);
    }

    let onCaptureSucceeded = (fileNames) => {
    	if (!active.current) return;
    	if (_.isEmpty(fileNames)) return onCaptureFailed();
    	clearTimeout(timeoutId.current);
    	getMapImageCallback(fileNames);
    	handleChange("phase", "ReviewMapSnapshot");
    }

    let captureMap = async () => {
    	setCaptureFailed(false);
    	setCapturing(true);
    	clearTimeout(timeoutId.current);
    	timeoutId.current = setTimeout(onCaptureFailed, 15000);
    	// A new value each time so repeat captures register as a prop change in the map.
    	await handleChange("captureMapNow", Date.now(), "async")
    }

	return(<>

		<InspectionWrapper
	      title="Capture Map Picture"
	      navButtons={[
	        {
	          className: "btn-secondary", 
	          onClick: cancel, 
	          label: <><i className="fa fa-angle-left mr-1"></i> BACK</>
	        },
	        {
	          className: "btn-outline-primary",
	          onClick: saveReportForLater,
	          label: "Save for Later"
	        },
	        {
	          className: "btn btn-primary",
	          onClick: captureMap,
	          disabled: capturing,
	          label: <><i class="fa fa-camera mr-1"></i> {captureFailed ? "Try Again" : "Capture"}</>
	        }
	      ]}
	    >

			<BMPLocationDisplay 
				bmpList={loggedBMPs || []} 
				reportState={reportState} 
				getMapImageCallback={onCaptureSucceeded}
				captureErrorCallback={onCaptureFailed}
				capture={reportState.captureMapNow}
				mapLoadedCallback={() => handleChange("mapCurrentlyLoaded", true)}
				mapUnloadedCallback={() => handleChange("mapCurrentlyLoaded", false)}
			/> 

		    {captureFailed ?
		    	<div className="alert alert-danger position-static mt-2" role="alert">
		    		The map image could not be captured or saved. Select Try Again. A map image is required to close out the inspection.
		    	</div>
		    : !capturing ? 
		    	<div className="col-12 mt-2 pb-4 mb-4 border-bottom">
		            <p className="mt-4 mb-0 fs-17"><strong>Ensure map is correctly positioned so that all BMPs are visible, then click the capture button below</strong></p>
		        </div> 
		    : <em><small>Capturing map image...</small></em> }

		</InspectionWrapper>
	</>)
}